import { Login } from './';
import SignUp from './SignUp';
import ResetPassword from './ResetPassword';

export default {
  path: 'login',
  name: 'login',
  childRoutes: [
    { path: 'login', name: 'Login', component: Login, isIndex: true },
    { path: 'signup', name: 'SignUp', component: SignUp, isIndex: true },
    { path: 'reset-password', name: 'ResetPassword', component: ResetPassword, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/login/route.js